// 首頁主按鈕與設定選項共用的霧面按鈕表面。
// === 使用圖片 ===
// 透過 CDialogButtonSurface 使用 cream-button-red.png / cream-button-green.png，詳見 dialog-skin.ts。
import type Phaser from 'phaser';
import { CDialogButtonSurface } from './dialog-skin';

export class CArcadeButtonSurface extends CDialogButtonSurface {
  constructor(scene: Phaser.Scene, width: number, height: number) {
    super(scene, 0, 0, width, height, false);
  }
}
